<template>
  <click-to-edit
    v-if="scope.row.isFieldViewable('card_weight')"
    v-model="scope.row.model.card_weight"
    :disabled="!scope.row.isFieldEditable('card_weight')"
    digits-only
    placeholder=""
    @input="scope.row.save()"
  ></click-to-edit>
  <CascadingElementHiddenProp v-else>{{scope.row.getHiddenPlaceholder('card_weight')}}</CascadingElementHiddenProp>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";
import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";

export default {
  name: 'cascading-element-weight-table-column',
  components: { CascadingScaleUnitSelect, CascadingElementHiddenProp, ClickToEdit },
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
